import { render } from "./AddNewDish.vue?vue&type=template&id=e424c768"
import script from "./AddNewDish.vue?vue&type=script&lang=js"
export * from "./AddNewDish.vue?vue&type=script&lang=js"

import "./AddNewDish.vue?vue&type=style&index=0&id=e424c768&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__